import { render, staticRenderFns } from "./TrainDeviationImportFromTraind.vue?vue&type=template&id=71a8c0fa"
import script from "./TrainDeviationImportFromTraind.vue?vue&type=script&lang=js"
export * from "./TrainDeviationImportFromTraind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports